"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHListControllerV3 = exports.KHListKeyV3 = void 0;
const KHController_1 = require("../../Input/KHController");
const KHInputSet_1 = require("../../Input/KHInputSet");
const KHInputProviderController_1 = require("../../Input/KHInputProviderController");
const KHInputKeyCompeting_1 = require("../../Input/Key/KHInputKeyCompeting");
const KHInputKeyRepeating_1 = require("../../Input/Key/KHInputKeyRepeating");
const KHInputKeyFromAxis_1 = require("../../Input/Key/KHInputKeyFromAxis");
const KHUnifiedInput_1 = require("../../Input/KHUnifiedInput");
var KHListKeyV3;
(function (KHListKeyV3) {
    KHListKeyV3[KHListKeyV3["Up"] = 0] = "Up";
    KHListKeyV3[KHListKeyV3["Down"] = 1] = "Down";
    KHListKeyV3[KHListKeyV3["Left"] = 2] = "Left";
    KHListKeyV3[KHListKeyV3["Right"] = 3] = "Right";
    KHListKeyV3[KHListKeyV3["Cancel"] = 4] = "Cancel";
    KHListKeyV3[KHListKeyV3["Confirm"] = 5] = "Confirm";
})(KHListKeyV3 || (exports.KHListKeyV3 = KHListKeyV3 = {}));
class KHListControllerV3 extends KHController_1.KHGenericController {
    constructor(inputSet, left, right, up, down, confirm, back) {
        const inputMap = new Map();
        inputMap.set(KHListKeyV3.Left, left);
        inputMap.set(KHListKeyV3.Right, right);
        inputMap.set(KHListKeyV3.Up, up);
        inputMap.set(KHListKeyV3.Down, down);
        inputMap.set(KHListKeyV3.Confirm, confirm);
        inputMap.set(KHListKeyV3.Cancel, back);
        super(inputMap, new Map(), inputSet);
    }
    static default() {
        const inputSet = new KHInputSet_1.KHInputSet("menu");
        const axisThreshold = 0.5;
        let left = KHUnifiedInput_1.KHUnifiedInput.FromConfig({ inputSet,
            buttons: [KHInputProviderController_1.KHPadInput.Left],
            keys: [Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.A],
            otherInputs: [
                new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickX, 0)), -axisThreshold)
            ]
        });
        let right = KHUnifiedInput_1.KHUnifiedInput.FromConfig({ inputSet,
            buttons: [KHInputProviderController_1.KHPadInput.Right],
            keys: [Phaser.Input.Keyboard.KeyCodes.RIGHT, Phaser.Input.Keyboard.KeyCodes.D],
            otherInputs: [
                new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickX, 0)), axisThreshold)
            ]
        });
        let up = KHUnifiedInput_1.KHUnifiedInput.FromConfig({ inputSet,
            buttons: [KHInputProviderController_1.KHPadInput.Up],
            keys: [Phaser.Input.Keyboard.KeyCodes.UP, Phaser.Input.Keyboard.KeyCodes.W],
            otherInputs: [
                new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickY, 0)), -axisThreshold)
            ]
        });
        let down = KHUnifiedInput_1.KHUnifiedInput.FromConfig({ inputSet,
            buttons: [KHInputProviderController_1.KHPadInput.Down],
            keys: [Phaser.Input.Keyboard.KeyCodes.DOWN, Phaser.Input.Keyboard.KeyCodes.S],
            otherInputs: [
                new KHInputKeyFromAxis_1.KHInputKeyKeyFromAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledAxial(inputSet, KHInputProviderController_1.KHPadAxis.LeftStickY, 0)), axisThreshold)
            ]
        });
        const competingLeft = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, left, right, false), 200, 200);
        const competingRight = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, right, left, true), 200, 200);
        const competingUp = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, up, down, false), 200, 200);
        const competingDown = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, down, up, true), 200, 200);
        const back = KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.BACKSPACE, Phaser.Input.Keyboard.KeyCodes.X], [KHInputProviderController_1.KHPadInput.B, KHInputProviderController_1.KHPadInput.X]);
        const confirm = KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.ENTER, Phaser.Input.Keyboard.KeyCodes.Z], [KHInputProviderController_1.KHPadInput.A]);
        return new KHListControllerV3(inputSet, competingLeft, competingRight, competingUp, competingDown, confirm, back);
    }
}
exports.KHListControllerV3 = KHListControllerV3;
